import { Box, Typography } from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import DocumentCard from 'components/documents/document-card'
import {
  Operations as DocumentOperations,
  operations as documentOperations
} from 'states/dux/document/operations'
import { Payload as DocumentPayload } from 'states/dux/document/types'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import {
  Operations as UserOperations,
  operations as userOperations
} from 'states/dux/user/operations'
import { Payload as UserPayload } from 'states/dux/user/types'
import State from 'states/types'
import { NivosFile } from 'types/nivos-file'
import {
  get,
  mapOperationsToDispatchProps,
  objectifyDateStringFields
} from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  document: DocumentPayload
  user: UserPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    document: DocumentOperations
    user: UserOperations
  }
}

type AppProps = StateProps & DispatchProps

const RecentDocumentsFC: React.FC<any> = (props: AppProps) => {
  const { operations } = props
  const [loading, setLoading] = React.useState(true)
  const [recentFiles, setRecentFiles] = React.useState<NivosFile[]>([])

  React.useEffect(() => {
    if (recentFiles.length < 1) {
      setLoading(true)
      void get('/document/file/recent/').then((data: NivosFile[]) => {
        const parsedData = data.map(file => objectifyDateStringFields(file))
        setRecentFiles(parsedData)
        setLoading(false)
      })
    }
  }, [])

  return (
    <Box padding={2}>
      {!loading && recentFiles.length > 0 && (
        <>
          <Box display={'flex'} alignItems={'center'}>
            <Typography variant={'h4'} flexGrow={1}>
              <strong>RECENTS</strong>
            </Typography>
          </Box>
          <Box
            width={1}
            maxWidth={1}
            minHeight={400}
            display={'flex'}
            alignItems={'center'}
            overflow={'auto'}
          >
            {recentFiles.map((_file, index) => (
              <Box
                key={index}
                sx={{ cursor: 'pointer' }}
                onClick={() => operations.document.setSelected(_file)}
              >
                <DocumentCard file={_file} />
              </Box>
            ))}
          </Box>
        </>
      )}
      {!loading && recentFiles.length === 0 && (
        <>
          <Box display={'flex'} alignItems={'center'}>
            <Typography variant={'h4'} flexGrow={1}>
              {props.layout.language.translations.recentDocuments}
            </Typography>
          </Box>
          <Box width={1} minHeight={200} display={'flex'} alignItems={'center'}>
            <Box padding={4} margin={'auto'}>
              <Typography variant="h3">No Data</Typography>
            </Box>
          </Box>
        </>
      )}
      {loading && <Typography variant={'h4'}>Loading...</Typography>}
    </Box>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    document: state.document,
    user: state.user
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  document: documentOperations,
  user: userOperations
})

const RecentDocuments = connect(
  mapStateToProps,
  mapDispatchToProps
)(RecentDocumentsFC)

export default RecentDocuments
